<template>
  <el-card
    class="!border-none"
    :body-style="{ height: '100%' }"
    v-loading="uploadLoading"
    :element-loading-text="uploadProgressText"
  >
    <div class="w-full h-full">
      <div class="flex items-center h-32px" v-if="canEdit">
        <p class="pl-10px border-l-3px text-18px border-color-primary">{{ title }}</p>
      </div>
      <el-page-header v-else :content="title" @back="cancel"></el-page-header>
      <el-form
        class="my-20px h-[calc(100%-128px)] overflow-y-auto overflow-x-hidden flex flex-col"
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="150px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题名称" prop="title">
              <el-input
                size="small"
                maxlength="50"
                placeholder="请输入"
                v-model="formData.title"
                clearable
                :disabled="!canEdit"
                class="title-input"
              >
                <span slot="suffix" class="px-5px text-12px">{{ formData.title.length }}/50</span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="副标题" prop="subtitle">
              <el-input
                size="small"
                maxlength="50"
                placeholder="请输入"
                v-model="formData.subtitle"
                clearable
                :disabled="!canEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="置顶等级" prop="isTop">
              <el-select size="small" v-model="formData.isTop" :disabled="!canEdit" class="w-full">
                <el-option
                  v-for="item in topList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="isTextColumn || isImageTextColumn">
            <el-form-item
              label="文字作者"
              :prop="isTextColumn || isImageTextColumn ? 'textAuthor' : ''"
            >
              <!-- <el-input
                size="small"
                placeholder="请输入"
                v-model="formData.textAuthor"
                clearable
                :disabled="!canEdit"
              ></el-input> -->
              <div class="flex">
                <el-select
                  disabled
                  size="small"
                  placeholder="请添加"
                  v-model="formData.textAuthor"
                  class="flex-1 mr-10px"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button size="small" type="primary" @click="openAuthorDialog(columnTextType)">{{
                  canEdit ? '添加' : '查看'
                }}</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="isTextColumn || isImageTextColumn">
            <el-form-item label="图片作者" prop="imageAuthor">
              <!-- <el-input
                size="small"
                placeholder="请输入"
                v-model="formData.imageAuthor"
                clearable
                :disabled="!canEdit"
              ></el-input> -->
              <div class="flex">
                <el-select
                  disabled
                  size="small"
                  placeholder="请添加"
                  v-model="formData.imageAuthor"
                  class="flex-1 mr-10px"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button
                  size="small"
                  type="primary"
                  @click="openAuthorDialog(columnImgTextType)"
                  >{{ canEdit ? '添加' : '查看' }}</el-button
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="isVideoColumn">
            <el-form-item label="视频作者" prop="videoAuthor">
              <!-- <el-input
                size="small"
                placeholder="请输入"
                v-model="formData.videoAuthor"
                clearable
                :disabled="!canEdit"
              ></el-input> -->
              <div class="flex">
                <el-select
                  disabled
                  size="small"
                  placeholder="请添加"
                  v-model="formData.videoAuthor"
                  class="flex-1 mr-10px"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <el-button size="small" type="primary" @click="openAuthorDialog(columnVideoType)">{{
                  canEdit ? '添加' : '查看'
                }}</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门" prop="deptSource">
              <el-select
                size="small"
                v-model="formData.deptSource"
                placeholder="请选择"
                :disabled="!canEdit"
                class="w-full"
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in orgList"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布栏目" prop="columnId">
              <el-select
                size="small"
                v-model="formData.columnId"
                placeholder="请选择"
                class="w-full"
                :disabled="!canEdit || [1, 3, 4, 5].includes(formData.workflowStatus)"
                filterable
                @change="columnChange"
              >
                <el-option
                  v-for="item in columnOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布时间">
              <el-date-picker
                v-model="formData.editPublishTime"
                type="datetime"
                :picker-options="pickerOptionsStart"
                placeholder="选择发布时间"
                :disabled="mode !== 'approve'"
                :clearable="false"
                class="!w-full"
                @change="handleChangeEditPublishTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="是否显示" prop="isShow">
              <el-switch v-model="formData.isShow" :disabled="!canEdit"> </el-switch>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="外链地址" prop="externalLink">
              <el-input
                size="small"
                maxlength="200"
                placeholder="请输入"
                v-model="formData.externalLink"
                clearable
                :disabled="!canEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标题样式" prop="titleStyle">
              <div class="flex items-center">
                <el-color-picker
                  v-model="formData.titleStyle.color"
                  :disabled="!canEdit"
                ></el-color-picker>
                <el-checkbox
                  class="ml-20px"
                  v-model="formData.titleStyle.fontWeight"
                  :disabled="!canEdit"
                  >加粗</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="允许下载通知"
              v-if="(isTextColumn || isImageTextColumn) && !isNewsColumn"
            >
              <el-radio-group
                v-model="formData.isAllowDownload"
                :prop="isTextColumn || isImageTextColumn ? 'isAllowDownload' : ''"
                :disabled="!canEdit"
              >
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" v-if="isImageTextColumn || isVideoColumn">
            <el-form-item
              label="封面图片"
              :prop="isImageTextColumn || isVideoColumn ? 'indexImage' : ''"
            >
              <uploadFile
                v-if="canEdit"
                :uploadText="'上传封面'"
                :filetype="3"
                :fileMaxsize="indexImgMaxsize"
                :fileAccept="indexImageAccept"
                :singleFile="true"
                @on-progress="handleIndexImageUploadProgress"
                @on-error="uploadLoading = false"
                @filesUploadComplete="handleIndexImageComplete"
              ></uploadFile>
              <div>
                <el-image
                  v-if="formData.indexImage"
                  :src="`${fileUrl}image/${formData.indexImage}`"
                  fit="contain"
                  class="w-88px h-88px border-1 border-dashed"
                ></el-image>
              </div>
              <span v-if="canEdit">{{ indexImageAccept }}, 最大{{ indexImgMaxsize }}M</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="(isTextColumn || isImageTextColumn) && !isNewsColumn">
            <el-form-item
              label="通知正文"
              :prop="isTextColumn || isImageTextColumn ? 'uploadNotification' : ''"
            >
              <uploadFile
                v-if="canEdit"
                :uploadText="'上传通知正文'"
                :filetype="2"
                :maxFileCount="1"
                :fileAccept="notificationAccept"
                :singleFile="false"
                :fileMaxsize="notificationFileMaxsize"
                @on-progress="handleNotificationUploadProgress"
                @on-error="uploadLoading = false"
                @filesUploadComplete="handleNotificationComplete"
                :fileList="notificationFileIdNameList"
                ref="uploadFileNotification"
              ></uploadFile>
              <div>
                <div
                  v-for="(item, index) in notificationFileIdNameList"
                  :key="item.id"
                  class="flex items-center"
                >
                  <a class="underline hyperlink-color mr-50px" :href="item.url" target="_blank">{{
                    item.fileName
                  }}</a>
                  <el-button
                    class="ml-50px"
                    size="mini"
                    @click="delNotificationFile(index)"
                    v-if="canEdit"
                    >删除</el-button
                  >
                </div>
              </div>
              <span v-if="canEdit"
                >{{ notificationFileAccept }}, 最大{{ notificationFileMaxsize }}M</span
              >
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="(isTextColumn || isImageTextColumn) && !isNewsColumn">
            <el-form-item
              label="附件"
              :prop="isTextColumn || isImageTextColumn ? 'attachFile' : ''"
            >
              <uploadFile
                v-if="canEdit"
                :uploadText="'上传附件'"
                :filetype="1"
                :singleFile="false"
                :fileMaxsize="attachFileMaxsize"
                @on-progress="handleAttachUploadProgress"
                @on-error="uploadLoading = false"
                @filesUploadComplete="handleAttachComplete"
                ref="uploadFile"
                :fileList="attachFileIdNameList"
              ></uploadFile>
              <div>
                <div
                  v-for="(item, index) in attachFileIdNameList"
                  :key="item.id"
                  class="flex items-center"
                >
                  <a class="underline hyperlink-color mr-50px" :href="item.url" target="_blank">{{
                    item.fileName
                  }}</a>
                  <el-button
                    class="ml-50px"
                    size="mini"
                    @click="delAttachFile(index)"
                    v-if="canEdit"
                    >删除</el-button
                  >
                </div>
              </div>
              <span v-if="canEdit">{{ attachFileAccept }}, 最大{{ attachFileMaxsize }}M</span>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="isVideoColumn">
            <el-form-item label="视频" :prop="isVideoColumn ? 'videoFile' : ''">
              <uploadFile
                v-if="canEdit"
                :uploadText="'上传视频'"
                :filetype="2"
                :singleFile="true"
                :fileMaxsize="videoFileMaxsize"
                :fileAccept="videoAccept"
                @on-progress="handleVideoUploadProgress"
                @on-error="uploadLoading = false"
                @filesUploadComplete="handleVideoComplete"
                ref="uploadVideoFile"
              ></uploadFile>
              <div>
                <div
                  v-for="(item, index) in videoFileIdNameList"
                  :key="item.id"
                  class="flex items-center"
                >
                  <a class="underline hyperlink-color mr-50px" :href="item.url" target="_blank">{{
                    item.fileName
                  }}</a>
                  <el-button class="ml-50px" size="mini" @click="delVideoFile(index)" v-if="canEdit"
                    >删除</el-button
                  >
                </div>
              </div>
              <span v-if="mode !== 'read'">{{ videoAccept }}, 最大{{ videoFileMaxsize }}M</span>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="!isVideoColumn">
          <richtextEditor
            v-if="canEdit && showEditor"
            @change="handleRichtextEditor"
            :content="formData.content"
            class="flex-1 text-editor"
            ref="richtextEditor"
            @typography="formData.isLayout = true"
          >
          </richtextEditor>
          <div v-else class="flex-1 flex detail-w">
            <div class="ql-container ql-snow min-h-full flex-1">
              <div class="ql-editor" v-html="formData.content"></div>
            </div>
          </div>
        </template>
      </el-form>
      <div class="text-center pt-20px border-t-1px border-color-default">
        <el-button
          type="primary"
          size="small"
          @click="save('save')"
          :loading="saveLoading"
          v-if="canEdit"
          >保存</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="save('submit')"
          :loading="saveLoading"
          v-if="
            (mode === 'create' || [0, 3, 4].includes(formData.workflowStatus)) &&
              columnDetail.workflow !== 0 &&
              canEdit
          "
          >提交</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="save('approve')"
          :loading="saveLoading"
          v-if="formData.workflowStatus === 1 && canEdit"
          >审批</el-button
        >
        <el-button type="primary" size="small" @click="preview">预览</el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </div>
    <approvalDialog :visible.sync="approvalDialogVisible" @save="approval" :data="approvalData" />
    <previewDialog
      ref="previewDialog"
      :visible.sync="previewDialogVisible"
      :data="previewData"
    ></previewDialog>
    <addAuthor
      v-if="showAddAuthor"
      :visible.sync="authorDialogVisible"
      :type="authorType"
      :disabled="!canEdit"
      :deptData="formData.deptSource"
      :authorData="authorData"
      :columnType="columnType"
      @save="setAuthor"
    />
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { FileApi } from '@wiz-api/file-management'
import { ColumnTableApi, ColumApi, ColumnFlowApi } from '@wiz-api/workbench'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { OrganizationApi } from '@wiz-api/abp-identity'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { keys } from 'lodash'
import { treeToOneArray } from '@/assets/js/Common'
import { informationPublishMap } from '../../../js/config'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const fileApi = new FileApi()
const columApi = new ColumApi()
const columnTableApi = new ColumnTableApi()
const columnFlowApi = new ColumnFlowApi()
const organizationApi = new OrganizationApi()
const dataCategoryApi = new DataCategoryApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const richtextEditor = () => {
  return import('@/components/RichtextEditor')
}
const uploadFile = () => {
  return import('@/components/UploadFile')
}
const approvalDialog = () => {
  return import('../../../components/PublishApproval')
}
const previewDialog = () => {
  return import('./PreviewDialog')
}
const addAuthor = () => {
  return import('../../../components/AddAuthor')
}
const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目
const columnOutSourceType = informationPublishMap.columnSource.columnFromThird // 外网栏目

export default {
  name: 'columnPublishManagementDialog',
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 当前点击的树形节点信息
    columnId: {
      type: String,
      default: '',
    },
    operationType: {
      type: String,
      default: 'create',
    },
  },
  components: {
    richtextEditor,
    uploadFile,
    approvalDialog,
    previewDialog,
    addAuthor,
  },
  data() {
    return {
      authorType: 1,
      showAddAuthor: false,
      authorDialogVisible: false,
      authorData: [],
      approvalDialogVisible: false,
      uploadLoading: false,
      videoName: '', // 视频名称
      attachFileName: '', // 附件名称
      file1: '', // 封面
      file2: '', // 附件
      file3: '', // 视频
      formData: {
        title: '',
        isTop: 0,
        textAuthor: [],
        attachFile: '',
        isShow: true,
        content: '',
        indexImage: '',
        imageAuthor: [],
        videoAuthor: [],
        externalLink: '',
        videoFile: '',
        subtitle: '',
        uploadNotification: '',
        isAllowDownload: true,
        titleStyle: {
          color: '#333333',
          fontWeight: false,
        },
        editPublishTime: null,
        columnId: '',
        deptSource: [],
        isLayout: false,
        workflowStatus: 0,
      },
      formRules: {
        title: [{ required: true, message: '请输入标题名称', trigger: 'blur' }],
        textAuthor: [{ required: true, message: '请选择文字作者', trigger: 'blur' }],
        imageAuthor: [{ required: false, message: '请选择图片作者', trigger: 'blur' }],
        isTop: [{ required: false, message: '请选择是否置顶', trigger: 'blur' }],
        isShow: [{ required: false, message: '请选择是否显示', trigger: 'blur' }],
        videoAuthor: [{ required: false, message: '请选择视频作者', trigger: 'change' }],
        indexImage: [{ required: true, message: '请上传封面图片', trigger: 'change' }],
        videoFile: [{ required: true, message: '请上传视频', trigger: 'change' }],
        isAllowDownload: [{ required: true, message: '请选择下载通知', trigger: 'change' }],
        deptSource: [{ required: true, message: '请选择部门', trigger: 'change' }],
      },
      tableLoading: false,
      saveLoading: false,
      attachFileList: [], // 附件上传显示的列表
      attachFileIdNameList: [], // 附件上传到文件系统后返回的信息
      notificationFileIdNameList: [],
      videoFileIdNameList: [],
      uploadProgressText: '', // 上传进度显示文本
      orgList: [],
      columnDetail: {},
      approvalData: {},
      showEditor: false,
      previewDialogVisible: false,
      previewData: {
        isShowSidebar: false,
        title: '',
        textAuthor: '',
        videoAuthor: '',
        editpublishTime: '',
        content: '',
        attachFile: '',
        type: '',
        deptSourceName: '',
      },
      columnOptions: [],
      pickerOptionsStart: {
        // 时间不能大于当前时间
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
      },
      columnCategoryList: [],
      columnType: 1,
      columnCategory: '',
      columnTextType,
      columnImgTextType,
      columnVideoType,
      userList: [],
      topList: [
        { label: '不置顶', value: 0 },
        { label: '置顶1', value: 5 },
        { label: '置顶2', value: 4 },
        { label: '置顶3', value: 3 },
        { label: '置顶4', value: 2 },
        { label: '置顶5', value: 1 },
      ],
    }
  },
  computed: {
    mode() {
      return this.$route.query.mode || this.operationType
    },
    title() {
      let str = ''
      if (this.isTextColumn) {
        str = '文字'
      } else if (this.isImageTextColumn) {
        str = '图文'
      } else {
        str = '视频'
      }
      if (this.mode === 'create' || this.mode === 'materialPublish') {
        return `新增${str}栏目发布`
      }
      if (this.mode === 'update') {
        return `编辑${str}栏目发布`
      }
      return `${str}栏目详情`
    },
    canEdit() {
      return !['read'].includes(this.mode)
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/`
    },
    isTextColumn() {
      return this.columnType === columnTextType
    },
    isImageTextColumn() {
      return this.columnType === columnImgTextType
    },
    isVideoColumn() {
      return this.columnType === columnVideoType
    },
    // 是否为外网栏目
    isFromOut() {
      return this.columnDetail.source === columnOutSourceType
    },
    // 封面图片接收文件类型
    indexImageAccept() {
      return 'jpg,png,gif'
    },
    attachFileAccept() {
      if (this.isTextColumn) {
        // return 'jpg,png'
        return '文件格式无限制'
      }
      if (this.isImageTextColumn) {
        // return 'jpg,png,word,pdf,excel,rar'
        return '文件格式无限制'
      }
      return 'jpg,png'
    },
    notificationFileAccept() {
      return '只能上传pdf文件'
    },
    videoAccept() {
      return 'mp4,wav'
    },
    notificationAccept() {
      return 'pdf'
    },
    // 封面图片大小限制
    indexImgMaxsize() {
      // 单位 M
      return 20
    },
    // 附件大小限制
    attachFileMaxsize() {
      // 单位 M
      return 1024
    },
    // 通知大小限制
    notificationFileMaxsize() {
      // 单位 M
      return 1024
    },
    // 视频大小限制
    videoFileMaxsize() {
      // 单位 M
      return 1024
    },
    // 附件上传限制数量
    attachFileCount() {
      return 3
    },
    // 是否新闻栏目
    isNewsColumn() {
      const category = _.find(this.columnCategoryList, { id: this.columnCategory })
      return category?.code === '0'
    },
  },
  watch: {},
  methods: {
    openAuthorDialog(type) {
      this.authorType = type
      this.authorData = _.concat(
        _.map(this.formData.textAuthor, (item) => {
          return {
            id: item,
            type: columnTextType,
          }
        }),
        _.map(this.formData.imageAuthor, (item) => {
          return {
            id: item,
            type: columnImgTextType,
          }
        }),
        _.map(this.formData.videoAuthor, (item) => {
          return {
            id: item,
            type: columnVideoType,
          }
        })
      )
      this.showAddAuthor = true
      this.authorDialogVisible = true
    },
    handleChangeEditPublishTime() {
      if (!this.formData.editPublishTime) {
        this.formData.editPublishTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      }
    },
    async getColumnCategory() {
      this.columnCategoryList = []
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'ColumnCategory',
        includeDetails: true,
      })
      if (!err) {
        this.columnCategoryList = res.dataItems
      }
    },
    approval() {
      if (this.$route.query.columnId) {
        this.$router.go(-1)
      } else {
        this.$emit('on-success')
      }
    },
    async getOrgData() {
      const [err, res] = await organizationApi.getAllListDetails({})
      if (!err && res?.items.length) {
        this.orgList = res?.items[0].children
      }
    },
    async getUserList(userIdList) {
      if (userIdList.length === 0) return
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        userIdList: _.filter(userIdList, (item) => {
          const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
          return uuidPattern.test(item)
        }),
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && res) {
        this.userList = res.items
      }
    },
    async setAuthor(data, deleteData) {
      const userIdList = []
      const deptList = []
      const deleteDeptIds = _.map(deleteData, (item) => {
        return item.deptId
      })
      this.formData.deptSource = _.difference(this.formData.deptSource, deleteDeptIds)
      _.forEach(data, (item) => {
        userIdList.push(item.id)
        if (item.deptId) {
          deptList.push(item.deptId)
        }
      })
      await this.getUserList(userIdList)
      this.formData.textAuthor = []
      this.formData.imageAuthor = []
      this.formData.videoAuthor = []
      _.forEach(data, (item) => {
        switch (item.type) {
          case columnTextType:
            this.formData.textAuthor.push(item.id || item.name)
            break
          case columnImgTextType:
            this.formData.imageAuthor.push(item.id || item.name)
            break
          case columnVideoType:
            this.formData.videoAuthor.push(item.id || item.name)
            break
          default:
            break
        }
      })
      this.formData.deptSource = _.uniq([...this.formData.deptSource, ...deptList])
    },
    // 删除附件之前的提示
    handleBeforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}?`)
    },
    // 删除附件
    handleRemove(file, fileList) {
      this.attachFileList = fileList
    },
    // 附件个数超出的提示
    handleExceed(files, fileList) {
      this.$message.warning(
        `附件最多可上传${this.attachFileCount}个文件, 本次选择了${
          files.length
        }个文件, 共选择了${files.length + fileList.length}个文件`
      )
    },
    // 获取页面附件列表上的附件id
    findSaveAttachFile() {
      const displayAttachFile = this.attachFileIdNameList.map((item) => {
        return item.id
      })
      return displayAttachFile.join(',')
    },
    // 获取页面附件列表上的附件id
    findSaveNotificationFile() {
      const displayAttachFile = this.notificationFileIdNameList.map((item) => {
        return item.id
      })
      return displayAttachFile.join(',')
    },
    save(type) {
      this.$refs.formRef.validate(async (valid, obj) => {
        if (valid) {
          const typeNameObj = {
            save: '保存',
            submit: '提交',
            approve: '审批',
          }
          // 有富文本且未智能排序进行提示
          if (!this.formData.isLayout && this.$refs.richtextEditor) {
            this.$confirm(`未智能排版，是否仍要${typeNameObj[type]}?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(async () => {
                this.saveData(type)
              })
              .catch(() => {})
          } else {
            this.saveData(type)
          }
        } else {
          const noValidList = keys(obj)
          const noValidDom = document.querySelector(`.el-form-item__label[for="${noValidList[0]}"]`)
          if (noValidDom) {
            noValidDom.scrollIntoView({
              behavior: 'smooth',
            })
          }
        }
      })
    },
    async saveData(type) {
      if (this.$refs.richtextEditor) {
        this.formData.content = this.$refs.richtextEditor.quill.root.innerHTML
      }
      this.formData.attachFile = this.findSaveAttachFile()
      this.formData.uploadNotification = this.findSaveNotificationFile()
      this.formData.editPublishTime = this.formData.editPublishTime
        ? dayjs(this.formData.editPublishTime).format('YYYY-MM-DD HH:mm:ss')
        : null
      let apiRequest
      let isExist
      const params = {
        body: {
          ...this.formData,
          lastModificationTime: null,
          columnId: this.formData.columnId,
          deptSource: this.formData.deptSource.length
            ? JSON.stringify(this.formData.deptSource)
            : null,
          textAuthor: this.formData.textAuthor.length ? this.formData.textAuthor.join(',') : null,
          imageAuthor: this.formData.imageAuthor.length
            ? this.formData.imageAuthor.join(',')
            : null,
          videoAuthor: this.formData.videoAuthor.length
            ? this.formData.videoAuthor.join(',')
            : null,
          titleStyle: JSON.stringify(this.formData.titleStyle),
        },
        header: {
          'wiz-sensitive-words': false,
        },
      }
      this.saveLoading = true
      // 1 =栏目为文字类型
      if (this.isTextColumn) {
        if (this.formData.id) {
          params.body.oldColumnId =
            this.formData.columnId === this.columnDetail.id ? null : this.columnDetail.id
          if (this.columnType !== this.columnDetail.type) {
            params.body.sourceType = this.columnDetail.type
            params.body.destinationType = this.columnType
            apiRequest = await columnTableApi.updateConvertColumn(params)
          } else {
            apiRequest = await columnTableApi.updateTextColumnTable(params)
          }
        } else {
          apiRequest = await columnTableApi.addTextColumnTable(params)
        }
      }
      // 2 = 栏目为图文类型
      if (this.isImageTextColumn) {
        if (this.formData.id) {
          params.body.oldColumnId =
            this.formData.columnId === this.columnDetail.id ? null : this.columnDetail.id
          if (this.columnType !== this.columnDetail.type) {
            params.body.sourceType = this.columnDetail.type
            params.body.destinationType = this.columnType
            apiRequest = await columnTableApi.updateConvertColumn(params)
          } else {
            apiRequest = await columnTableApi.updateImageColumnTable(params)
          }
        } else {
          apiRequest = await columnTableApi.addImageColumnTable(params)
        }
      }
      // 3 = 栏目为视频类型
      if (this.isVideoColumn) {
        params.body.isLayout = true
        if (this.formData.id) {
          params.body.oldColumnId =
            this.formData.columnId === this.columnDetail.id ? null : this.columnDetail.id
          apiRequest = await columnTableApi.updateVideoColumnTable(params)
        } else {
          apiRequest = await columnTableApi.addVideoColumnTable(params)
        }
      }
      if (!apiRequest[0]) {
        const res = apiRequest[1]
        if (type === 'approve') {
          this.approvalDialogVisible = true
          this.saveLoading = false
          return
        }
        if (type === 'submit') {
          if (this.formData.workflowStatus === 0) {
            await columnFlowApi.submit({
              columnTableId: res.id,
              type: this.columnType,
            })
          } else {
            if (!this.formData.nextTaskId) {
              this.$message.warning('未获取到下一步审批节点!')
              this.saveLoading = false
              return
            }
            await columnFlowApi.approve({
              body: {
                columnTableId: res.id,
                type: this.columnType,
                isPass: true,
                approve: '',
                taskId: this.formData.nextTaskId,
              },
            })
          }
          this.$message.success('提交成功')
        } else {
          this.$message.success('保存成功')
        }
        if (this.$route.query.columnId) {
          this.$router.go(-1)
        } else {
          this.$emit('on-success')
        }
      }
      this.saveLoading = false
    },
    cancel() {
      if (this.$route.query.columnId) {
        this.$router.go(-1)
      } else {
        this.$emit('close')
      }
    },
    // 处理富文本编辑器传递回来的内容
    handleRichtextEditor(content) {
      this.formData.isLayout = false
      this.formData.content = content
    },
    async getAttachFileContent(fileList, index) {
      if (index >= fileList.length) return
      const fileId = fileList[index]
      if (!fileId) {
        this.getAttachFileContent(fileList, index + 1)
        return
      }
      this.uploadLoading = true
      // 获取图片内容
      const [error, result] = await fileApi.get(fileId)
      this.uploadLoading = false
      if (!error) {
        const fileType = result.name
          .split('.')
          .at(-1)
          .toLowerCase()
        if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].includes(fileType)) {
          const contentType = {
            png: 'image/png',
            jpeg: 'image/jpeg',
            jpg: 'image/jpeg',
            mp4: 'video/mp4',
            pdf: 'application/pdf',
          }
          this.attachFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.fileUrl}preview/${fileId}?contentType=${contentType[fileType]}`,
          })
        } else {
          this.attachFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.fileUrl}${fileId}/download`,
          })
        }
      }
      this.getAttachFileContent(fileList, index + 1)
    },
    async getNotificationFileContent(fileId) {
      this.uploadLoading = true
      // 获取图片内容
      const [error, result] = await fileApi.get(fileId)
      this.uploadLoading = false
      if (!error) {
        const fileType = result.name
          .split('.')
          .at(-1)
          .toLowerCase()
        if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].includes(fileType)) {
          const contentType = {
            png: 'image/png',
            jpeg: 'image/jpeg',
            jpg: 'image/jpeg',
            mp4: 'video/mp4',
            pdf: 'application/pdf',
          }
          this.notificationFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.routerBase}/attachments-view?fileId=${fileId}&fileName=${result.name}&contentType=${contentType[fileType]}`,
          })
        } else {
          this.notificationFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.fileUrl}${fileId}/download`,
          })
        }
      }
    },
    async getVideoFileContent(fileId) {
      this.uploadLoading = true
      // 获取视频名称
      const [error, result] = await fileApi.get(fileId)
      this.uploadLoading = false
      if (!error) {
        const fileType = result.name
          .split('.')
          .at(-1)
          .toLowerCase()
        if (['mp4'].includes(fileType)) {
          this.videoFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.routerBase}/attachments-view?fileId=${fileId}&fileName=${result.name}&contentType=video/mp4`,
          })
        } else {
          this.videoFileIdNameList.push({
            id: fileId,
            fileName: result.name,
            url: `${this.fileUrl}${fileId}/download`,
          })
        }
      }
    },
    // 删除单个附件
    delAttachFile(index) {
      this.attachFileIdNameList.splice(index, 1)
      this.$refs.uploadFile.fileRemove(index)
    },
    // 封面上传进度
    handleIndexImageUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },
    // 封面上传完成
    handleIndexImageComplete(item) {
      this.uploadLoading = false
      this.formData.indexImage = item.id
      this.$refs.formRef.clearValidate('indexImage')
      this.$forceUpdate()
    },
    // 附件上传进度
    handleAttachUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },
    // 附件上传完成
    handleAttachComplete(item) {
      this.uploadLoading = false
      const fileType = item.fileName
        .split('.')
        .at(-1)
        .toLowerCase()
      if (['pdf', 'jpg', 'jpeg', 'png', 'mp4'].includes(fileType)) {
        const contentType = {
          png: 'image/png',
          jpeg: 'image/jpeg',
          jpg: 'image/jpeg',
          mp4: 'video/mp4',
          pdf: 'application/pdf',
        }
        this.attachFileIdNameList.push({
          id: item.id,
          fileName: item.fileName,
          url: `${this.routerBase}/attachments-view?fileId=${item.id}&fileName=${item.fileName}&contentType=${contentType[fileType]}`,
        })
      } else {
        this.attachFileIdNameList.push({
          fileName: item.fileName,
          name: item.fileName,
          id: item.id,
          url: `${this.fileUrl}${item.id}/download`,
        })
      }
    },
    // 通知上传进度
    handleNotificationUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },
    // 通知上传完成
    handleNotificationComplete(item) {
      this.uploadLoading = false
      const fileType = item.fileName
        .split('.')
        .at(-1)
        .toLowerCase()
      if (['pdf'].includes(fileType)) {
        const contentType = {
          pdf: 'application/pdf',
        }
        this.notificationFileIdNameList.push({
          id: item.id,
          fileName: item.fileName,
          url: `${this.fileUrl}preview/${item.id}?contentType=${contentType[fileType]}`,
        })
      } else {
        this.notificationFileIdNameList.push({
          fileName: item.fileName,
          name: item.fileName,
          id: item.id,
          url: `${this.fileUrl}${item.id}/download`,
        })
      }
    },
    // 删除单个通知
    delNotificationFile(index) {
      this.notificationFileIdNameList.splice(index, 1)
      this.$refs.uploadFileNotification.fileRemove(index)
    },
    // 删除视频
    delVideoFile(index) {
      this.videoFileIdNameList.splice(index, 1)
      this.$refs.uploadVideoFile.fileRemove(index)
      this.formData.videoFile = ''
    },
    // 视频上传进度
    handleVideoUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },
    // 视频上传完成
    handleVideoComplete(item) {
      this.uploadLoading = false
      this.formData.videoFile = item.id
      const fileType = item.fileName
        .split('.')
        .at(-1)
        .toLowerCase()
      if (['mp4'].includes(fileType)) {
        this.videoFileIdNameList.push({
          id: item.id,
          fileName: item.fileName,
          url: `${this.routerBase}/attachments-view?fileId=${item.id}&fileName=${item.fileName}&contentType=video/mp4`,
        })
      } else {
        this.videoFileIdNameList.push({
          id: item.id,
          fileName: item.fileName,
          name: item.fileName,
          url: `${this.fileUrl}${item.id}/download`,
        })
      }
      this.$refs.formRef.clearValidate('videoFile')
      this.$forceUpdate()
    },
    async getColumnDetail() {
      const curColumnId = this.$route.query.columnId || this.columnId
      const [err, res] = await columApi.getColumnDetail(curColumnId)
      if (!err) {
        this.columnDetail = res
        this.columnType = this.columnDetail.type
        if (this.isImageTextColumn) {
          this.formRules.imageAuthor[0].required = true
        } else if (this.isVideoColumn) {
          this.formRules.videoAuthor[0].required = true
        }
        this.columnCategory = this.columnDetail.category
        this.approvalData.type = this.columnType
      }
    },
    async getDetail() {
      // if (!_.isEmpty(this.detailData)) {
      //   this.formData = {
      //     ...this.formData,
      //     ..._.cloneDeep(this.detailData),
      //     textAuthor: this.detailData.textAuthor ? this.detailData.textAuthor.split(',') : [],
      //     imageAuthor: this.detailData.imageAuthor ? this.detailData.imageAuthor.split(',') : [],
      //     videoAuthor: this.detailData.videoAuthor ? this.detailData.videoAuthor.split(',') : [],
      //   }
      //   const ids = [
      //     ...this.formData.textAuthor,
      //     ...this.formData.imageAuthor,
      //     ...this.formData.videoAuthor,
      //   ]
      //   await this.getUserList(ids)
      //   this.showEditor = true
      //   this.approvalData.taskId = this.formData.nextTaskId
      //   this.approvalData.columnTableId = this.formData.id
      //   return
      // }
      const id = _.isEmpty(this.detailData) ? this.$route.query.id : this.detailData.id
      let err
      let res
      // 文字栏目详情
      if (this.isTextColumn) {
        ;[err, res] = await columnTableApi.getTextColumnTableDetail(id)
      }
      // 图文栏目详情
      if (this.isImageTextColumn) {
        ;[err, res] = await columnTableApi.getImageColumnTableDetail(id)
      }
      // 视频栏目详情
      if (this.isVideoColumn) {
        ;[err, res] = await columnTableApi.getVideoColumnTableDetail({ id })
      }
      if (!err) {
        const data = { ...res }
        if (res.titleStyle) {
          data.titleStyle = JSON.parse(res.titleStyle)
        } else {
          data.titleStyle = {
            color: '#000000',
            fontWeight: false,
          }
        }

        this.formData = {
          ...data,
          textAuthor: res.textAuthor ? res.textAuthor.split(',') : [],
          imageAuthor: res.imageAuthor ? res.imageAuthor.split(',') : [],
          videoAuthor: res.videoAuthor ? res.videoAuthor.split(',') : [],
          deptSource: res.deptSource ? JSON.parse(res.deptSource) : [],
        }
        this.approvalData.taskId = this.formData.nextTaskId
        this.approvalData.columnTableId = this.formData.id
        const ids = [
          ...this.formData.textAuthor,
          ...this.formData.imageAuthor,
          ...this.formData.videoAuthor,
        ]
        await this.getUserList(ids)
      }
      this.showEditor = true
    },
    preview() {
      this.previewData = this.$options.data().previewData
      if (this.formData.externalLink) {
        window.open(this.formData.externalLink)
        return
      }
      if (this.$refs.richtextEditor) {
        this.formData.content = this.$refs.richtextEditor.quill.root.innerHTML
      }
      this.formData.attachFile = this.findSaveAttachFile()
      this.formData.uploadNotification = this.findSaveNotificationFile()
      this.previewData.isShowSidebar = this.columnDetail.isShowSidebar
      this.previewData.type = this.columnType
      this.previewData.deptSourceName = ''
      if (this.formData.deptSource.length) {
        const deptNameList = []
        _.forEach(this.formData.deptSource, (item) => {
          const dept = _.find(this.orgList, { id: item })
          if (dept) {
            deptNameList.push(dept.displayName)
          }
        })
        this.previewData.deptSourceName = deptNameList.join(',')
      }
      const author =
        this.columnType === columnVideoType
          ? this.formData.videoAuthor
          : [...this.formData.textAuthor, ...this.formData.imageAuthor]
      this.previewData = {
        ...this.previewData,
        ...this.formData,
        author: _.map(author, (item) => {
          const user = _.find(this.userList, { id: item })
          return user?.name || item
        }).join(','),
        textAuthorName: _.map(this.formData.textAuthor, (item) => {
          const user = _.find(this.userList, { id: item })
          return user?.name || item
        }).join(','),
        imageAuthorName: _.map(this.formData.imageAuthor, (item) => {
          const user = _.find(this.userList, { id: item })
          return user?.name || item
        }).join(','),
        videoAuthorName: _.map(this.formData.videoAuthor, (item) => {
          const user = _.find(this.userList, { id: item })
          return user?.name || item
        }).join(','),
      }
      // this.$refs.previewDialog.detailInfo = _.cloneDeep(this.previewData)
      if (this.mode === 'create') {
        this.$refs.previewDialog.handleAttachFile(this.previewData)
      }
      this.previewDialogVisible = true
    },
    async getColumnOptions() {
      const [err, res] = await columApi.tree(0, {
        isOnlyShowOwnRight: true,
      })
      if (!err) {
        const data = treeToOneArray(res, 'child')
        this.columnOptions = _.filter(data, (item) => {
          if ([1, 2].includes(this.columnDetail.type)) {
            return (
              [1, 2].includes(item.type) && item.isLeaf
              // && item.workflow === this.columnDetail.workflow
            )
          }
          return (
            item.type === this.columnDetail.type && item.isLeaf
            // && item.workflow === this.columnDetail.workflow
          )
        })
      }
      this.formData.columnId = this.columnDetail.id
    },
    columnChange() {
      const column = _.find(this.columnOptions, { id: this.formData.columnId })
      if (column) {
        this.columnType = column.type
        this.columnCategory = column.category
        this.approvalData.type = this.columnType
      }
    },
  },
  async mounted() {
    await this.getColumnCategory()
    await this.getColumnDetail()
    await this.getColumnOptions()
    this.uploadLoading = true
    if (this.mode !== 'create') {
      await this.getDetail()
    } else {
      this.formData.editPublishTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      this.showEditor = true
    }
    await this.getOrgData()
    this.uploadLoading = false
    this.$nextTick(() => {
      this.$refs.formRef && this.$refs.formRef.clearValidate() // 清除新增表单验证
      if (this.formData.attachFile) {
        const attachFileIdList = this.formData.attachFile.split(',')
        if (Array.isArray(attachFileIdList)) {
          this.getAttachFileContent(attachFileIdList, 0)
        }
      }
      if (this.formData.uploadNotification) {
        const notificationFileIdList = this.formData.uploadNotification.split(',')
        if (Array.isArray(notificationFileIdList)) {
          notificationFileIdList.forEach((fileId) => {
            this.getNotificationFileContent(fileId)
          })
        }
      }
      if (this.formData.videoFile) {
        this.getVideoFileContent(this.formData.videoFile)
      }
      this.$forceUpdate()
    })
  },
}
</script>

<style lang="scss" scoped>
.tree-scrollbar-style::-webkit-scrollbar {
  width: 6px;
}
// ::v-deep .el-tree-node__content {
//   height: 36px;
// }
::v-deep {
  .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
  .table-input,
  .table-select {
    .el-input__inner {
      border: none;
      padding: 0;
      background: transparent;
      &:focus,
      &:hover,
      &:active {
        background: transparent;
      }
    }
  }
}
::v-deep .table-select {
  .el-icon-arrow-up {
    line-height: 36px !important;
  }
}
::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .ql-align-center img {
  display: inline-block;
}
// ::v-deep .uploader-box {
//   left: 5px !important;
//   top: 0px !important;
//   background-color: transparent !important;
//   border: none !important;
// }
// ::v-deep .uploader-example .uploader-btn {
//   background-color: var(--buttonPrimaryBg) !important;
//   color: var(--buttonTextColor) !important;
//   height: 36px;
//   line-height: 36px;
// }
::v-deep .text-editor {
  .ql-container {
    min-height: calc(100% - 43px) !important;
    height: auto;
    overflow-y: auto;
    max-height: calc(100vh - 335px);
  }
}
::v-deep .title-input {
  &.el-input--suffix {
    .el-input__inner {
      padding-right: 48px;
      &:active,
      &:focus,
      &:hover {
        padding-right: 72px;
      }
    }
    .el-input__suffix-inner {
      background-color: var(--inputBg);
    }
  }
  &.is-disabled.el-input--suffix {
    .el-input__suffix-inner {
      background-color: var(--inputDisabledBg);
    }
  }
  &:hover {
    .el-input__inner {
      padding-right: 72px;
    }
  }
}
</style>
